import { ChevronLeft, Minus, Package, Plus, Trash2 } from "lucide-react";
import { brl, imgUrl } from "@/lib/api";
import { cardCls } from "@/components/mobile/parts";
import { cn } from "@/lib/utils";

function Thumb({ p }) {
  return (
    <span className="grid h-14 w-14 shrink-0 place-items-center overflow-hidden rounded-xl bg-[#e3f2fd]">
      {p.image_url ? <img src={imgUrl(p.image_url)} alt={p.name} className="h-full w-full object-cover" loading="lazy" /> : <Package className="h-6 w-6 text-[#1565c0]/50" />}
    </span>
  );
}

export function ProductList({ products, cart, onPick, onDec, title, onBack }) {
  const qtyOf = (id) => cart.filter((i) => i.product_id === id).reduce((s, i) => s + i.qty, 0);
  return (
    <div className="space-y-3">
      {onBack && (
        <button onClick={onBack} className="flex items-center gap-1 text-sm font-semibold text-[#1565c0]" data-testid="m-back-categories">
          <ChevronLeft className="h-4 w-4" />Categorias<span className="text-slate-400">/</span><span className="text-slate-700">{title}</span>
        </button>
      )}
      <ul className="space-y-2" data-testid="m-product-list">
        {products.map((p) => {
          const q = qtyOf(p.id);
          // Comanda (onDec informado): com quantidade, mostra "− n +" como no carrinho; sem quantidade, só o "+".
          if (onDec) {
            return (
              <li key={p.id}>
                <div className={cn(cardCls, "flex w-full items-center gap-2 p-2.5", q > 0 && "ring-2 ring-[#1565c0]")}>
                  <button onClick={() => onPick(p)} className="flex min-w-0 flex-1 items-center gap-3 text-left transition-transform active:scale-[0.99]" data-testid={`m-product-${p.id}`}>
                    <Thumb p={p} />
                    <span className="min-w-0 flex-1">
                      <span className="line-clamp-2 text-sm font-semibold leading-snug">{p.name}</span>
                      <span className="font-mono text-sm font-bold text-[#1565c0]">{brl(p.price)}</span>
                      {p.option_groups?.length > 0 && <span className="ml-2 text-[10px] text-slate-400">com opções</span>}
                    </span>
                  </button>
                  {q > 0 && (
                    <>
                      <button onClick={() => onDec(p)} aria-label={`Tirar 1 ${p.name}`} className="grid h-10 w-10 shrink-0 place-items-center rounded-full border border-slate-300 bg-white" data-testid={`m-product-dec-${p.id}`}>
                        {q <= 1 ? <Trash2 className="h-4 w-4 text-red-500" /> : <Minus className="h-4 w-4" />}
                      </button>
                      <span className="grid h-7 min-w-7 place-items-center rounded-full bg-[#1565c0] px-2 text-xs font-bold text-white" data-testid={`m-product-qty-${p.id}`}>{q}</span>
                    </>
                  )}
                  <button onClick={() => onPick(p)} aria-label={`Adicionar ${p.name}`} className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-[#e3f2fd] text-[#1565c0]" data-testid={`m-product-inc-${p.id}`}><Plus className="h-5 w-5" /></button>
                </div>
              </li>
            );
          }
          return (
            <li key={p.id}>
              <button onClick={() => onPick(p)} className={cn(cardCls, "flex w-full items-center gap-3 p-2.5 text-left transition-transform active:scale-[0.99]", q > 0 && "ring-2 ring-[#1565c0]")} data-testid={`m-product-${p.id}`}>
                <Thumb p={p} />
                <span className="min-w-0 flex-1">
                  <span className="line-clamp-2 text-sm font-semibold leading-snug">{p.name}</span>
                  <span className="font-mono text-sm font-bold text-[#1565c0]">{brl(p.price)}</span>
                  {p.option_groups?.length > 0 && <span className="ml-2 text-[10px] text-slate-400">com opções</span>}
                </span>
                {q > 0 && <span className="grid h-7 min-w-7 place-items-center rounded-full bg-[#1565c0] px-2 text-xs font-bold text-white" data-testid={`m-product-qty-${p.id}`}>{q}</span>}
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-[#e3f2fd] text-[#1565c0]"><Plus className="h-5 w-5" /></span>
              </button>
            </li>
          );
        })}
      </ul>
      {!products.length && <p className="py-10 text-center text-sm text-slate-500">Nenhum produto encontrado.</p>}
    </div>
  );
}
